export default "__VITE_ASSET__Bmi8oh2B__"